import * as types from '../constants/actionTypes';

const initialState = {
  selectedShoppableCPTCode: 0,
  selectedSearchResult: {},
  results: [ ],
  facility: null,
  searchTerm: "",
  searchList: [],
  cost: 0,
  categoryId: 0
}

const searchResults = (state = initialState, action) => {
   switch (action.type) {

    
      case 'RECIEVE_RESULTS':
         return {
        ...state,
        results: action.results
      }
      case 'RECIEVE_FACILITY':
         return {
        ...state,
        facility: action.facility
      }
      case 'SELECT_SHOPPABLE':
         return {
        ...state,
        shoppableCptId: action.shoppableCPTCodeCombinedPricingID,
        selectedSearchResult: state.results.filter(item => item.ShoppableCPTCodeCombinedPricingID === action.shoppableCPTCodeCombinedPricingID)
      }
      case 'SELECT_SEARCH_TERM':
         return {
        ...state,
        searchTerm: action.searchTerm
      }
      case 'SET_COST':
         return {
        ...state,
        cost: action.cost
      }
      case types.RECEIVE_SEARCH_LIST:
         return {
        ...state,
        searchList: action.list
      }
      case types.HANDLE_CATEGORY_SELECT:
         return {
        ...state,
        categoryId: action.categoryId
      }
      
    default:
      return state;
  }
  
}

export default searchResults



// WEBPACK FOOTER //
// ./src/reducers/searchResults.js